import BaseField from "./BaseField";
import Factor from "./Factor";

/** Facteur d'influence */
export default class FactorField extends BaseField {
    /** Nom d'affichage coté client */
    public Name: string;
    /** Libellé du facteur */
    public Label: string;
    /** Retour des valeurs devant être enregistrées */
    public Value: Factor[];
    public Unit: string;
    public IsGlobal: boolean;
    public IsStatic: boolean;
    public CumulNode: boolean;
    public Temporality: FactorTemporalityEnum;
    public FactorType: FactorTypeEnum;
    public HasData: boolean;
}

/** Type du facteur */
enum FactorTypeEnum {
    Combinable = 1,
    Average = 2,
    Percent = 3
}

/** Type temporel du facteur */
enum FactorTemporalityEnum {
    Limited = 1,
    Instant = 2,
    Indexed = 3
}
